/**
 * Guard used to suppress row "unsaved" (ungray) marking during programmatic
 * bulk updates such as NMEA accept, where sections/values are rewritten without
 * the user actually editing rows. User-driven edits (typing, selects, infolist
 * changes) are NOT wrapped and continue to ungray their row as expected.
 */
let suspendCount = 0;

export const isSavedStateMarkingSuspended = (): boolean => suspendCount > 0;

/**
 * Runs `fn` (which typically dispatches setSections / calls setValue) with
 * saved-state marking suspended, then releases the guard on a macrotask so it
 * stays active while React commits and flushes the passive effects triggered by
 * the update (the effects that would otherwise ungray the rows).
 */
export const runWithSavedStateMarkingSuspended = (fn: () => void): void => {
  suspendCount += 1;
  try {
    fn();
  } finally {
    setTimeout(() => {
      suspendCount = Math.max(0, suspendCount - 1);
    }, 0);
  }
};
